var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LL_wrapper"},_vm._l((_vm.mylessions),function(lession){return _c('LectureWelcomeBox',{key:lession.id,attrs:{"lession":lession}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }